class Columns {
    constructor(key) {
        const data = this.data();
        if (Object.hasOwnProperty.call(data, key)) {
            return data[key];
        }
        return undefined;
    }
    data() {
        return {
            stadium: [{
                title: '場地編號',
                dataIndex: 'fieldCode',
                key: 'fieldCode',
            }, {
                title: '場地名稱',
                dataIndex: 'fieldName',
                key: 'fieldName',
            },
            {
                title: '場地類型',
                dataIndex: 'sportTypeCode',
                key: 'sportTypeCode',
                scopedSlots: { customRender: 'sportTypeCode' },
            },
            {
                title: '所屬場館',
                dataIndex: 'venueCode',
                key: 'venueCode',
            },
            {
                title: '場地狀態',
                dataIndex: 'status',
                key: 'status',
                width: 150,
                scopedSlots: { customRender: 'status' },
            },
            {
                title: '添加時間',
                dataIndex: 'createdTime',
                key: 'createdTime',
                width: 180,
            }]
        }
    }
}

export default function (key, options) {
    let col = new Columns(key);
    if (col && options) {
        col.push({
            title: '操作',
            key: 'operation',
            //fixed: 'right',
            width: 330,
            scopedSlots: { customRender: 'action' },
        })
    }
    return col;
};